import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import theme from "../../theme";

const TextFieldContent = styled(TextField)`
  //   background-color: #red !important;
  & input {
    padding: 8px;
  }
`;
const Label = styled("div")`
  display: flex;
  flex-direction: row;
  color: #333c44;
  margin-bottom: 10px;
`;
const TextFieldComponent = (props) => {
  const { value, label, important, type } = props;
  return (
    <div>
      <Label>
        {label} {important ? <div style={{ color: "#e24c4c" }}>*</div> : null}
      </Label>
      <TextFieldContent
        fullWidth
        variant="filled"
        type={type || "text"}
        InputProps={{
          disableUnderline: true,
          sx: {
            backgroundColor: `${theme.textFieldColor} !important`,
          },
        }}
        value={value ?? ''}
        multiline = {type === 'textarea' ? true : false}
        rows = {type === 'textarea' ? 4 : 1}
      ></TextFieldContent>
    </div>
  );
};

export default TextFieldComponent;
